import { useDispatch, useSelector } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";
import { Checkbox } from "@similarweb/ui-components";

import advancedSearchFilteringTrackingService from "../../services/tracking";
import { updateIsNewOnlyAction } from "../../store/action-creators";
import { selectIsNewOnlyEnabled } from "../../store/selectors";
import advancedFilteringI18nKeys from "../../utils/i18n";

import { StyledCheckboxContainer } from "./styles";

type Props = {
    isDisabled?: boolean;
};

const IsNewOnlyCheckboxContainer = ({ isDisabled = false }: Props) => {
    const { translate } = useTranslate();

    const dispatch = useDispatch();

    const isNewOnlyEnabled = useSelector(selectIsNewOnlyEnabled);

    const handleIsNewOnlyChanged = (): void => {
        advancedSearchFilteringTrackingService.trackIsNewOnlyChanged(!isNewOnlyEnabled);

        dispatch(updateIsNewOnlyAction(!isNewOnlyEnabled));
    };

    return (
        <StyledCheckboxContainer>
            <Checkbox
                selected={isNewOnlyEnabled}
                label={translate(advancedFilteringI18nKeys.onlyNewMatchesCheckboxLabel)}
                isDisabled={isDisabled}
                onClick={handleIsNewOnlyChanged}
            />
        </StyledCheckboxContainer>
    );
};

export default IsNewOnlyCheckboxContainer;
